import React, { Component } from "react";

export default class Loader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
    };
  }
  componentDidMount() {
    this.isLoaded();
  }

  isLoaded = () => {
    if (document.readyState !== "complete") {
      const yes = setTimeout(() => {
       // console.log(document.readyState);
        this.isLoaded();
      }, 50);
    } else {
      this.setState({ loaded: true });
    }
  };
  render() {
    if (!this.state.loaded) {
      return (
        <div className="loaderWrapper">
          <div className="loaderContent">
            Loading {this.state.loaded ? "yes" : "no"}
          </div>
        </div>
      );
    }else{
        return "";
    }
  }
}
